export const ownerKeys = {
  units: ['owner', 'units'] as const,
  me: (teamId: number | null) => ['owner', 'me', teamId] as const,
  calendarOf: (unitId: number) => ['owner', 'calendar', unitId] as const,
  calendar: (unitId: number, from: string, to: string) =>
    ['owner', 'calendar', unitId, from, to] as const
};
